module.exports = __webpack_public_path__ + "media/images/img-carta-ba506d33ac399e8cf40fb21c45c49c69.png";